import * as React from 'react';
import { DataSignal } from 's-js';
import SuperCritical from 'lib/supercritical';
import { noDefault } from 'lib/eventWrappers';

import { RowSelector } from 'portcall/gridcomponents/model';
import { PageAction } from './pagestateenums';

import { RowSelectorView } from 'portcall/gridcomponents/view';

export const ExportSelectionControls = SuperCritical(({ model: m } : { model : {
    PageAction : DataSignal<PageAction>,
    ShowConfirmExport : DataSignal<boolean>,
    RowSelector : RowSelector
}}) =>
    m.PageAction() === PageAction.SelectForExport ?
        <div className="export-selection-controls">
            <YesNoConfirmation model={m} />
            <RowSelectorView model={m.RowSelector} />
        </div> : null
);

let YesNoConfirmation = SuperCritical(({ model: m } : { model : {
    PageAction : DataSignal<PageAction>,
    ShowConfirmExport : DataSignal<boolean>
}}) =>
    <span className="yes-no-confirmation">
        <span className="yes-no-question-text">Export selected?</span>
        <a href="" onClick={noDefault(() => m.PageAction(PageAction.View))}>No</a>
        <span className="pc-icon-bullet"></span>
        <a href="" onClick={noDefault(() => m.ShowConfirmExport(true))}>Yes, Export</a>
    </span>
);


// WEBPACK FOOTER //
// ./apps/portcall/quickbooksexports/exportselectioncontrols.tsx